import React from 'react';
import { Link } from './common/NextAdapters';
import { GenreTile } from './genre-tile';

export function CategoryGrid({ categories = [] }) {
  if (!categories || categories.length === 0) return null;

  return (
    <section className="py-6 sm:py-10">
      <div className="mx-auto max-w-[1600px] gutter">
        <div className="flex items-end gap-4">
          <h2 className="text-xl sm:text-2xl font-bold tracking-tight text-foreground display">Browse by genre</h2>
          <Link
            href="/categories"
            className="ml-auto shrink-0 rounded-full border border-white/10 px-3 py-1 text-xs sm:text-sm text-muted-foreground transition-colors hover:border-white/25 hover:text-foreground focus-visible:outline-none"
          >
            All genres
          </Link>
        </div>

        <ul className="mt-5 grid grid-cols-2 gap-3 sm:grid-cols-3 sm:gap-4 lg:grid-cols-4 xl:grid-cols-6 list-none p-0">
          {categories.map((category) => (
            <li key={category.id || category.Id}>
              <GenreTile
                category={category}
                compact
                sizes="(max-width: 640px) 45vw, (max-width: 1024px) 30vw, 16vw"
              />
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default CategoryGrid;
